import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Folder = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Folder' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,10 L2,6 L2,2 L10,2 L13,6 L22,6 L22,10 L2,10 Z M2,10 L22,10 L22,22 L2,22 L2,10 Z' />
  </StyledIcon>
);
